var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCloseCircle = function SvgIconCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11Zm15.652-3.218-3.184 3.187 3.228 3.24a1.051 1.051 0 0 1 0 1.483 1.04 1.04 0 0 1-1.476 0l-3.231-3.242-3.24 3.243a1.045 1.045 0 0 1-1.476-1.478l3.244-3.246-3.2-3.211a1.053 1.053 0 0 1 0-1.483 1.04 1.04 0 0 1 1.476 0l3.202 3.214 3.181-3.184a1.043 1.043 0 1 1 1.476 1.477Z",
    fill: "currentColor"
  })));
};
export default SvgIconCloseCircle;